import React from 'react';

import {
  BapSearchAd,
  AdImage
} from '@schibsted-nmp/search-frontend-components/react';

import type { MartailerProduct } from '../utils/MartailerApi.js';

export type SimpleBapSearchAdProps = {
  layout?: 'grid' | 'list';
  onClick?: () => void;
  products: Array<MartailerProduct>;
};

export type LabelRenderProps = {
  className?: string;
  classes: {
    badge: string;
    info: string;
    warning: string;
    success: string;
    [key: string]: string;
  };
};

export function SponsoredProductAd({
  layout = 'grid',
  onClick,
  products
}: SimpleBapSearchAdProps) {
  const product = products[0];
  if (!product) return null;
  const bapAd = convertToBapFormat(product);

  const IMAGE_SIZES =
    '(min-width: 1300px) 306px, (min-width: 1010px) 316px, (min-width: 768px) 33vw, (min-width: 480px) 50vw, 100vw';

  return (
    <BapSearchAd
      ad={bapAd}
      currentTime={Date.now()}
      id={bapAd.ad_id}
      imageSizes={IMAGE_SIZES}
      layout={layout}
      onClick={onClick}
      url={bapAd.canonical_url}
      image={
        layout === 'grid'
          ? () => (
              <div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '12px 8px'
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: 500,
                      color: '#020202'
                    }}
                  >
                    Advertisement
                  </span>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    style={{
                      color: '#0063fb',
                      textDecoration: 'none',
                      fontSize: '13px',
                      fontWeight: 400
                    }}
                  >
                    Ad info
                  </a>
                </div>
                {/* Ad Image with reduced height */}
                <div>
                  <AdImage
                    aspectClass="aspect-3/4"
                    height={bapAd.image.height}
                    width={bapAd.image.width}
                    url={bapAd.image.url}
                    crop={true}
                    sizes={IMAGE_SIZES}
                  />
                </div>
              </div>
            )
          : undefined
      }
    />
  );
}

function convertToBapFormat(product: MartailerProduct) {
  return {
    ad_id: product.adId,
    canonical_url: product.link,
    distance: null,
    extras: [],
    flags: [],
    heading: product.title,
    image: {
      aspect_ratio: 1.3333333333333333,
      height: 400,
      url: product.imageLink,
      width: 533
    },
    labels: [],
    location: '',
    main_search_key: 'SEARCH_ID_BAP_COMMON',
    organisation_name: product.organisationName,
    price: {
      currency_code: 'EUR',
      amount: product.price,
      price_unit: '€'
    },
    timestamp: 1234567890,
    trade_type: 1
  };
}
